import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { popularComics } from '@/mocks/home';

export default function PopularComics() {
  return (
    <section className="py-16 md:py-24">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-10 md:mb-14">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-900">
              热门漫画
            </h2>
            <p className="mt-2 text-sm text-foreground-500">最受读者欢迎的韩国漫画作品</p>
          </div>
          <Link
            to="/category"
            className="text-sm text-foreground-600 hover:text-primary-500 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {popularComics.map((comic) => (
            <ComicCard key={comic.id} {...comic} />
          ))}
        </div>
      </div>
    </section>
  );
}